import React from 'react'
import Bg from '../../images/shapes/bg_pattern_4.svg'


const PageTitle = (props) => {
    const hasPhoto = Boolean(props.bgImage);
    const bgUrl = hasPhoto ? props.bgImage : Bg;
    const sectionStyle = hasPhoto
        ? {
            backgroundImage: `linear-gradient(rgba(11, 19, 43, 0.45), rgba(11, 19, 43, 0.60)), url(${bgUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
        }
        : { backgroundImage: `url(${bgUrl})` };

    return (
        <section className="page_banner_section text-center" style={sectionStyle}>
            <div className="container">
                <div className="heading_focus_text text-white">
                    {props.pageTop}
                    <span className="badge bg-secondary">{props.pagesub}</span>
                </div>
                <h1 className="page_title mb-0 text-white">{props.pageTitle}</h1>
            </div>
        </section>
    )
}

export default PageTitle;